import styled from "styled-components"

export const StyledList = styled.ul`
        list-style-type:none;
`